import { render, staticRenderFns } from "./FormatoPedidos.vue?vue&type=template&id=1ce3ff1c"
import script from "./FormatoPedidos.vue?vue&type=script&lang=js"
export * from "./FormatoPedidos.vue?vue&type=script&lang=js"
import style0 from "./FormatoPedidos.vue?vue&type=style&index=0&id=1ce3ff1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports